import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import { SelectList } from 'react-widgets';
import ArrayUtil from '../../../../../utils/ArrayUtil';
import { generateDimGroupNoForm } from '../../../../../utils/DimensionUtil';
import { getCommunicationTemplateForAsmt } from '../../../../../utils/TemplateUtil';
import { LegacyInputTextComponent, DropdownWithValidation } from '../../../../../components/prime-formik';
import { getEntityListWithAccount } from '../../../../../utils/AppUtil';

export const General = (props) => {
  const { editing } = props;
  return (
    <div className="p-grid p-fluid">
      <div className="p-col p-sm-12 p-md-6 form-group" key="title">
        <label className="field-label" htmlFor="title">
          <FormattedMessage id="temp.title" defaultMessage="Title" />
        </label>
        <FormattedMessage id="attrs.name" defaultMessage="Name">
          {text => (
            <Field
              id="title"
              name="title"
              component={LegacyInputTextComponent}
              placeholder={text}
              disabled={!editing}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

General.propTypes = {
  editing: PropTypes.bool.isRequired,
};

export class EmailTemplates extends Component {
  render() {
    const { account, editing } = this.props;
    const accountTemplates = getEntityListWithAccount(account, 'communicationTemplates');
    const templates = getCommunicationTemplateForAsmt(accountTemplates);

    // const { templates } = props;
    const invites = templates.invites.map(temp => ({
      value: temp.id,
      label: temp.name,
    }));

    const thanks = templates.thanks.map(temp => ({
      value: temp.id,
      label: temp.name,
    }));

    const reminders = templates.reminders.map(temp => ({
      value: temp.id,
      label: temp.name,
    }));

    const feedbacks = templates.feedbacks.map(temp => ({
      value: temp.id,
      label: temp.name,
    }));
    return (
      <div className="p-grid p-fluid">
        <h3 className="section-title p-col" key="title">
          <FormattedMessage id="attrs.email_templates" defaultMessage="Email Templates" />
        </h3>
        <div className="p-col-12">
          <div className="p-grid">
            <div className="p-col-6 p-sm-6 p-lg-3 form-group" key="invite">
              <label className="field-label" htmlFor="inviteTemplateId">
                <FormattedMessage id="attrs.invite_email_template" defaultMessage="Invite Email Template" />
              </label>
              <Field
                id="invite"
                name="inviteTemplateId"
                component={DropdownWithValidation}
                options={invites}
                disabled={!editing}
              />
            </div>
            <div className="p-col-6 p-sm-6 p-lg-3 form-group" key="thank">
              <label className="field-label" htmlFor="thankYouTemplateId">
                <FormattedMessage id="attrs.thank_email_template" defaultMessage="Thank You Email Template" />
              </label>
              <Field
                id="thankyou"
                name="thankYouTemplateId"
                component={DropdownWithValidation}
                options={thanks}
                disabled={!editing}
              />
            </div>
            <div className="p-col-6 p-sm-6 p-lg-3 form-group" key="reminder">
              <label className="field-label" htmlFor="reminderTemplateId">
                <FormattedMessage id="attrs.reminder_email_template" defaultMessage="Reminder Email Template" />
              </label>
              <Field
                id="reminder"
                name="reminderTemplateId"
                component={DropdownWithValidation}
                options={reminders}
                disabled={!editing}
              />
            </div>
            <div className="p-col-6 p-sm-6 p-lg-3 form-group" key="feedback">
              <label className="field-label" htmlFor="feedbackTemplateId">
                <FormattedMessage id="attrs.feedback_email_template" defaultMessage="Feedback Email Template" />
              </label>
              <Field
                id="feedback"
                name="feedbackTemplateId"
                component={DropdownWithValidation}
                options={feedbacks}
                disabled={!editing}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EmailTemplates.propTypes = {
  editing: PropTypes.bool.isRequired,
  account: PropTypes.objectOf(PropTypes.any).isRequired,
};

export const DimensionNoFormSelection = (props) => {
  const { dimensions, text, defaultDimension } = props;
  return (
    <div>
      <div className="row">
        <h3 className="col-md-12">{text}</h3>
      </div>
      <div className="row">
        <div className="col-md-12 select-list-section">
          <SelectList
            data={dimensions}
            readOnly
            multiple
            valueField="name"
            textField="displayName"
            defaultValue={defaultDimension}
          />
        </div>
      </div>
    </div>
  );
};

DimensionNoFormSelection.propTypes = {
  dimensions: PropTypes.arrayOf(PropTypes.any).isRequired,
  text: PropTypes.string.isRequired,
  defaultDimension: PropTypes.arrayOf(PropTypes.any),
};

DimensionNoFormSelection.defaultProps = {
  defaultDimension: [],
};

export const Dimensions = (props) => {
  const { dimensions } = props;
  const dimensionGroups = ArrayUtil.chunk(dimensions, 4);
  const options = {
    readOnly: true,
  };
  return (
    <div>
      <h3 className="section-title">
        <FormattedMessage id="attrs.dimensions" defaultMessage="Dimensions" />
      </h3>
      <div className="dimension-section">{generateDimGroupNoForm(dimensionGroups, options)}</div>
    </div>
  );
};

Dimensions.propTypes = {
  dimensions: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export const InterestDimensionSelectionNoForm = (props) => {
  const { dimensions, fieldName, checked } = props;
  const itemList = dimensions.map((item) => {
    const itemId = item.name
      .split(' ')
      .join('_')
      .toLowerCase();
    return (
      <div className="col-md-12" key={itemId}>
        <div>
          <label htmlFor={itemId}>{item.displayName}</label>
        </div>
      </div>
    );
  });
  const checkbox = (
    <div>
      <div className="row">
        <h3 className="col-md-12">
          <input type="checkbox" checked={checked} disabled />
          {' '}
          <FormattedMessage id="jobMatching.interestSection" defaultMessage="Interests Section">
            {text => (
              <span className="field-label" htmlFor={fieldName}>
                {text}
              </span>
            )}
          </FormattedMessage>
        </h3>
      </div>
      <div className="panel panel-default panel-interest">
        <div className="panel-body">{itemList}</div>
      </div>
    </div>
  );
  return checkbox;
};

InterestDimensionSelectionNoForm.propTypes = {
  dimensions: PropTypes.arrayOf(PropTypes.any).isRequired,
  fieldName: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
};
